import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAbortController } from "./hooks/useAbortController";

const useFetchTableData = (fetchAction, dataSelector) => {
  const { signal } = useAbortController();
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.dashboard?.[dataSelector]?.data);
  const status = useSelector(
    (state) => state.dashboard?.[dataSelector]?.status
  );
  const lenderId = useSelector((state) => state.account.lenderId);
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchAction({ lenderId, role: selectedRole, signal }));
    }
  }, [dispatch, status, lenderId, fetchAction, selectedRole, signal]);

  const retry = useCallback(
    () => dispatch(fetchAction({ lenderId, role: selectedRole, signal })),
    [dispatch, fetchAction, lenderId, selectedRole, signal]
  );

  return { data, status, retry };
};

export default useFetchTableData;
